// lib/features/theme/themeSlice.js
import { createSlice } from '@reduxjs/toolkit'
import { getSystemTheme } from '@/lib/theme'

const PREFERENCE_CYCLE = ['system', 'light', 'dark']

const initialState = {
    mode: 'light',
    preference: 'system',
}

const themeSlice = createSlice({
    name: 'theme',
    initialState,
    reducers: {
        toggleTheme(state) {
            state.mode = state.mode === 'light' ? 'dark' : 'light'
            state.preference = state.mode
        },
        cycleTheme(state) {
            const currentIndex = PREFERENCE_CYCLE.indexOf(state.preference)
            const nextPreference = PREFERENCE_CYCLE[(currentIndex + 1) % PREFERENCE_CYCLE.length]
            state.preference = nextPreference
            state.mode = nextPreference === 'system' ? getSystemTheme() : nextPreference
        },
        setTheme(state, action) {
            if (typeof action.payload === 'string') {
                state.mode = action.payload
                state.preference = action.payload
                return
            }

            state.mode = action.payload.mode
            state.preference = action.payload.preference ?? state.preference
        },
    },
})

export const { toggleTheme, cycleTheme, setTheme } = themeSlice.actions
export default themeSlice.reducer
